import { Dialog, Toast } from "antd-mobile";
import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  FormLabel,
  FormControl,
} from "react-bootstrap";
import { Divider, Space, Tag, Avatar } from "antd";
import PsContext from "../../context";
import { jsonToQuery } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Image, List } from "antd-mobile";
import { FloatButton } from "antd";
import { Tabs } from "antd";
import $ from "jquery";
import { PlusCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import ListServiceRequests from "./listServiceRequests";
const Service = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [action, setAction] = useState("listtypes");
  const [viewData,setViewData]=useState(null);
  useEffect(() => {
    listRequestType();
  }, []);
  const listRequestType = () => {
    setLoader(true);
    axios.get(ServiceUrl.REQUEST.SERVICE_TYPE).then((res) => {
      if (res["data"].status == "1") {
        setServiceTypes(res["data"].data);
        setLoader(false);
      }
    });
    setLoader(false);
  };

  useEffect(() => { }, []);
  return (
    <>
      {
        action === 'listtypes' && (<>
          <Header title="Service Requests" backAction={true} rightActions={[]} />
          <div className="page-content-wrapper">
            <br />
            <div className="container">
              <Card className="mb-2">
                <Card.Body className="fs-6">
                  {serviceTypes.map((item) => {
                    return <Button
                      onClick={() => {
                        setAction('listrequests');
                        setViewData(item);
                      }}
                      style={{ marginTop: '10px' }}
                      variant="success"
                      className="btn btn-block"
                    >
                      {item.request_type_name}
                    </Button>

                  })}
                </Card.Body>
              </Card>
            </div>
          </div>
        </>)
      }
      {
        action === 'listrequests' && (<>
          <ListServiceRequests requestType={viewData} />
        </>)
      }
    </>
  );
};
export default Service;
